export const timelineTargetHighlightClassName =
  'border-accent/35 bg-accent/8 ring-1 ring-inset ring-accent/25 shadow-sm shadow-black/15 transition-[background-color,border-color,box-shadow] duration-300';
